import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';

import { fetchTruckConsumption } from './thunk';

const truckConsumptionAdapter = createEntityAdapter();

const initialState = truckConsumptionAdapter.getInitialState({
  loading: false,
  error: null,
});

const truckConsumptionSlice = createSlice({
  name: 'truckConsumption',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTruckConsumption.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTruckConsumption.fulfilled, (state, { payload }) => {
        state.loading = false;
        truckConsumptionAdapter.setAll(state, payload);
      })
      .addCase(fetchTruckConsumption.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      });
  },
});

export const { selectAll: selectAllTruckConsumption } =
  truckConsumptionAdapter.getSelectors(
    ({ truckConsumption }) => truckConsumption
  );

export const selectTruckConsumptionLoading = ({ truckConsumption }) =>
  truckConsumption.loading;
export const selectTruckConsumptionError = ({ truckConsumption }) =>
  truckConsumption.error;

export const truckConsumptionReducer = truckConsumptionSlice.reducer;
